<section class="section" *ngIf="products.length">

  <div class="section-head">

    <h2>{{ title }}</h2>

    <a
      *ngIf="seeAllLink"
      class="see-all"
      [routerLink]="seeAllLink">
      {{ isBn ? 'সব দেখুন' : 'See all' }} &raquo;
    </a>

    <button
      *ngIf="canExpand"
      type="button"
      class="see-all"
      (click)="expand()">
      {{ isBn ? 'সব দেখুন' : 'See all' }} &raquo;
    </button>

  </div>

  <div class="grid" [style.--cols]="cols">

    <article
      class="card"
      [class.out]="p.stock <= 0"
      *ngFor="let p of visible; trackBy: trackByProduct"
      (click)="openProduct(p.id)">

      <div class="img-wrap">

        <span class="badge out-badge" *ngIf="p.stock <= 0">
          {{ t('outOfStock') }}
        </span>

        <span class="badge discount-badge" *ngIf="p.stock > 0 && p.discount > 0">
          -{{ p.discount | bnNumber }}%
        </span>

        <img
          loading="lazy"
          decoding="async"
          [src]="getImage(p.imageUrl || p.image_url)"
          (error)="onImgError($event)"
          [alt]="languageService.productName(p)"
        />

        <ng-container *ngIf="p.stock > 0">

          <button
            type="button"
            class="add-btn"
            *ngIf="qty(p) === 0"
            (click)="add(p, $event)"
            aria-label="Add to cart">
            +
          </button>

          <div class="stepper" *ngIf="qty(p) > 0" (click)="$event.stopPropagation()">
            <button type="button" (click)="decrease(p, $event)" aria-label="Decrease">&minus;</button>
            <span>{{ qty(p) | bnNumber }}</span>
            <button type="button" (click)="increase(p, $event)" aria-label="Increase">+</button>
          </div>

        </ng-container>

      </div>

      <div class="info">

        <div class="price-line">

          <span class="price">
            {{ getFinalPrice(p) | bnNumber:'৳' }}
          </span>

          <span class="old-price" *ngIf="p.discount > 0">
            {{ p.price | bnNumber:'৳' }}
          </span>

        </div>

        <h3 [title]="languageService.productName(p)">{{ languageService.productName(p) }}</h3>

        <p class="unit">
          <ng-container *ngIf="p.unit"><ng-container *ngIf="p.quantity">{{ p.quantity | bnNumber }} </ng-container>{{ languageService.translateUnit(p.unit) }}</ng-container>
        </p>

      </div>

    </article>

  </div>

</section>
